<template>
	<div class="fleetuse-logo" aria-label="Fleetuse logo">
		<img src="@/assets/fleetuse-logo.png" alt="Fleetuse logo" />
		<img src="@/assets/radar.png" class="rotating" alt="Fleetuse radar" />
		<span class="d-inline">Fleetuse</span>
	</div>
</template>

<script>
export default {
	name: 'FleetuseLogo'
};
</script>

<style scoped lang="scss">
.fleetuse-logo {
	text-align: center;
	font-weight: bold;
	font-size: 24px;
	height: 64px;
	position: relative;
	padding-left: 67px;
	display: inline-block;

	img {
		position: absolute;
		left: -5px;
		top: 0;
		height: 64px;
	}

	span {
		line-height: 64px;
	}
}

@keyframes rotating {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.rotating {
	animation: rotating 20s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/FleetuseLogo.vue